<ng-container>
    <nb-form-field>
        <input #search class="search" nbInput fullWidth fieldSize="small" type="text" placeholder="Filter..." (keydown.enter)="onSearch(search.value)">
        <button nbSuffix nbButton ghost (click)="toggleFilter(search.value)">
            <nb-icon [icon]="filter ? 'search-outline' : 'close-outline'"
                        pack="eva"
                        [attr.aria-label]="filter ? 'filter list' : 'reset list'">
            </nb-icon>
        </button>
    </nb-form-field>
</ng-container>
